import {RendererProps} from "../RendererProps";
import {ReactElement} from "react";
import {ensureNotObject} from "../common";

export function RenderAddUpdateUnitType(props: RendererProps): ReactElement {
    const name = props.variables["name"];

    return <div>{ensureNotObject(name)}</div>;
}